/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useTracking } from '@vp/react-tracking';
// import { CAContext } from '../contexts/CAContext';
import { useNRLogging } from './useNRLogging';
import { useCallback, useContext } from 'react';
import { getVariation } from '@vp/ab-reader';
import { experimentConfig } from '../../config/experiment-config';
import { CAContext } from '../../contexts/CAContext';
import { ChatbotContext } from '../../contexts/ChatbotContext';

const useCustomTracking = (): {
  sendExperimentEvent: (experimentDetail: string) => void;
  sendTrackingEvent: (
    eventName: 'Chatbot Viewed' | 'Chatbot Clicked' | 'Chat Initiated',
    label: string,
    eventDetail: string,
    category?: 'GEN AI Chatbot' | 'Global Chat',
    additionalInfo?: { [x: string]: string | boolean },
  ) => void;
} => {
  const {
    chatState: { chatSession },
  } = useContext(CAContext);
  const {
    state: { sessionId },
  } = useContext(ChatbotContext);
  const { logCustomAttributesNR } = useNRLogging();

  // const {
  //   chatState: { locale }
  // } = useContext(CAContext);

  /** use for sending Experiment Tracking Event ,
   *  Event name will always be Experiment Clicked
   *  mandatory  experimentDetail field
   */
  const sendExperimentEvent = useCallback((experimentDetail: string) => {
    try {
      const variationKey = getVariation(experimentConfig.experimentName);
      const expEventDetails: { [x: string]: any } = {
        //   label: `${requestor} View`,
        experimentName: experimentConfig.experimentName,
        variationName: variationKey,
        experimentDetail,
      };

      (window as any)?.tracking?.track('Experiment Clicked', { ...expEventDetails });
    } catch (err) {
      const error = err as Error;
      logCustomAttributesNR('help-anywhere-error-events-experiment', {
        logLevel: 'error',
        message: 'Event',
        errorName: error.name,
        errorMessage: error.message,
        experimentDetail,
      });
    }
  }, []);
  /** use for sending GA Tracking Event ,
   *  Event name will be among 'Fly-Out Viewed' | 'Fly-Out Clicked' | 'Fly-Out Closed'
   *  mandatory  Label field
   */
  const sendTrackingEvent = useCallback(
    (
      eventName: 'Chatbot Viewed' | 'Chatbot Clicked' | 'Chat Initiated',
      label: string,
      eventDetail: string,
      category?: 'GEN AI Chatbot' | 'Global Chat',
      additionalInfo?: { [x: string]: string | boolean },
    ) => {
      try {
        let eventCategory = category;
        if (!eventCategory) {
          eventCategory = 'GEN AI Chatbot';
        }
        const eventDetails: { [x: string]: any } = {
          label,
          category: eventCategory,
          eventDetail,
          ...additionalInfo,
        };
        if (chatSession === 'chatbotSession') {
          eventDetails.chatbotSessionId = sessionId;
        }
        console.log('Tracking Event:', eventName, eventDetails);
        /** Add Product details to experiment data if true */
        (window as any)?.tracking?.track(eventName, eventDetails);
      } catch (err) {
        const error = err as Error;
        logCustomAttributesNR('ca-chatbot-error-events', {
          eventName,
          label,
          errorName: error.name,
          errorStack: error.stack,
          message: error.message,
          logLevel: 'error',
        });
      }
    },
    [chatSession, sessionId],
  );

  return { sendExperimentEvent, sendTrackingEvent };
};
export { useCustomTracking };
